import I18n from 'I18n';
import Features from 'self-service-api/constants/Features';

// @ts-expect-error dependency missing types
import BUYER_INTENT_IMG from 'bender-url!pricing-pages-lib/images/keyFeatures/Buyer_Intent.png';
// @ts-expect-error dependency missing types
import DATA_ENRICHMENT_IMG from 'bender-url!pricing-pages-lib/images/keyFeatures/Data_Enrichment.png';
// @ts-expect-error dependency missing types
import FORM_SHORTENING_IMG from 'bender-url!pricing-pages-lib/images/keyFeatures/Form_Shortening.png';
import { DE, ES, FR, JA, PT } from 'self-service-api/constants/Languages';
const SUPPORTED_LANGS = ['en', 'es', 'fr', 'de', 'pt', 'ja', 'nl'];
const CMS_BASE_URL = 'https://f.hubspotusercontent00.net/hubfs/53';
const getImageUrl = extension => CMS_BASE_URL + extension;
const getDataEnrichmentImages = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
      return getImageUrl(`/International%20Web/data-enrichment/Company-record-Re-enrichmen-${langToUse.toUpperCase()}.png`);
    case PT:
      return getImageUrl(`/International%20Web/data-enrichment/Company-record-Re-enrichmen-${langToUse.toUpperCase()}.jpg`);
    default:
      return DATA_ENRICHMENT_IMG;
  }
};
const getBuyerIntentImages = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/International%20Web/buyer-intent/buyer-intent-filters-${langToUse.toLowerCase()}.png`);
    default:
      return BUYER_INTENT_IMG;
  }
};
const getFormShorteningImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/International%20Web/form-shortening/form-shortening-submissions-other-values-${langToUse.toLowerCase()}.png`);
    default:
      return FORM_SHORTENING_IMG;
  }
};
export const getLocalizedImages = feature => {
  switch (feature) {
    case Features.DATA_ENRICHMENT:
      return getDataEnrichmentImages();
    case Features.BUYER_INTENT:
      return getBuyerIntentImages();
    case Features.FORM_SHORTENING:
      return getFormShorteningImage();
    default:
      return [];
  }
};